import { RoleBundleItem } from './role-bundle-item';

export interface RoleBundle {
  id: string;
  name: string;
  description: string | null;
  /** System-seeded predefined bundles: not editable, not deactivatable. Duplicate one to edit. */
  isSystem: boolean;
  /** Deactivated bundles are hidden from new assignments but keep their existing role rows on staff. */
  isActive: boolean;
  items?: RoleBundleItem[];
  created: Date;
  modified: Date;
}

export interface PredefinedRoleBundle {
  name: string;
  description: string;
  /** Role ids from the code registry (see `_registrations.ts`). */
  roleKeys: string[];
}

/**
 * Default bundles seeded per tenant. Each layers on top of the previous:
 * Associate → Manager → Agent → Admin.
 */
export const PREDEFINED_ROLE_BUNDLES: PredefinedRoleBundle[] = [
  {
    name: 'Associate',
    description: 'Minimal permissions focused on selling and viewing what they have sold.',
    roleKeys: ['py_Manager', 'cus_Viewer'],
  },
  {
    name: 'Manager',
    description: 'Associate permissions plus selective editing of customer data.',
    roleKeys: ['py_Manager', 'cus_Editor', 'clm_Viewer', 'dsh_Viewer'],
  },
  {
    name: 'Agent',
    description: 'Manager permissions plus inviting distributors and adjusting some of their data.',
    roleKeys: ['py_Manager', 'cus_Editor', 'clm_Viewer', 'dsh_Viewer', 'dist_TagManager'],
  },
  {
    name: 'Admin',
    description: 'Agent permissions plus some tenancy-wide configuration and program pricing.',
    roleKeys: ['py_Manager', 'cus_Editor', 'clm_Viewer', 'dsh_Editor', 'dist_Manager'],
  },
];
